import _ from 'lodash'
import * as service from '../../services'
import { getOptionFromTypeCategory } from '../../utils/formikUpdate'

const CATEGORY_IDS = [1, 2, 3, 4, 5, 6, 7, 8]
const RIESGOS_OTROS = 91

export const inconveniencesItems = async inconveniences => {
  let items = []
  const response = await service.getCategoryTypeAll()
  const { res: ctgTypeAll } = response
  if (!ctgTypeAll) return console.log('Falló conexión getCategoryTypeAll ::', response)
  const uniqByKey = _.uniqBy(ctgTypeAll, 'key')

  _.forEach(CATEGORY_IDS, catId => {
    const optionsForCategory = _.filter(uniqByKey, ['idCategoria', catId])
    const findIdCtgr = _.find(inconveniences, ['id', catId])
    const { attributes } = findIdCtgr ?? {}

    if (!_.includes([1, 7], catId)) {
      _.forEach(attributes, attrib => {
        const key = Object.keys(attrib)[0]
        items.push({
          name: key,
          category: catId,
          typecategory: attrib[key].id,
          initvalue: attrib[key].value,
          label: attrib[key].label,
          chip: true,
        })
      })
      return
    }

    _.forEach(optionsForCategory, obj => {
      const options = getOptionFromTypeCategory(obj.key, ctgTypeAll)
      let objToReturn = {
        x: 12,
        s: 12,
        m: 6,
        name: obj.key,
        category: catId,
        typecategory: obj.id_ctgT,
        initvalue: '',
        options: Object.keys(options).length ? options : null,
        label: obj.descripcion,
        chip: false,
      }

      const keysAttributesAll = _.map(attributes, o => Object.keys(o)[0])
      if (_.includes(keysAttributesAll, obj.key)) {
        const attrib = _.find(attributes, objAtt => Object.keys(objAtt)[0] === obj.key)
        if (RIESGOS_OTROS === attrib[obj.key].id)
          objToReturn.initvalue = attrib[obj.key].value
        else objToReturn.initvalue = attrib[obj.key].id
      }
      items.push(objToReturn)
    })
  })
  return items
}
